export const ValidationType = {
  required: 'required',
  minlength: 'minLength',
  maxLength: 'maxLength',
  pattern: 'pattern',
  defaultError: 'defaultError',
};

const validateField = (value, rules = [], messages = {}) => {
  const trimmed = typeof value === 'string' && value ? value.trim() : '';
  const errors = [];

  rules.forEach(rule => {
    if (rule.type === ValidationType.required && !trimmed) {
      errors.push(messages.required || 'This field is required.');
    }

    if (rule.type === ValidationType.minlength && trimmed.length < rule.value) {
      errors.push(
        messages.minLength || `Minimum length is ${rule.value} characters.`
      );
    }

    if (rule.type === ValidationType.maxLength && trimmed.length > rule.value) {
      errors.push(
        messages.maxLength || `Maximum length is ${rule.value} characters.`
      );
    }

    if (rule.type === ValidationType.pattern && !rule.value.test(trimmed)) {
      errors.push(messages.pattern || 'Invalid format.');
    }

    if (rule.type === ValidationType.defaultError) {
      errors.push(messages.defaultError);
    }
  });

  return errors;
};

/*
 * Prevent non-digit characters (except for navigation keys)
 * Use for input fields of type "number" to avoid scientific notation (e.g., "1e10")
 */
export const filterNonDigitInput = event => {
  const isNavigationKey = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Home',
    'End',
  ].includes(event.key);
  const isDigit = /^\d$/.test(event.key);
  if (!isDigit && !isNavigationKey) {
    event.preventDefault();
  }
};

export default validateField;
